import { SelectProps } from "antd";
import { ReactElement, ReactNode } from "react";
export type PairValue = [number, string];

export type Dispatch<T> = (action: T) => void;
export type ProviderProps = {
  children: ReactNode;
};

export interface IUser {
  id: number;
  login: string;
  name: string;
  partner_id: number;
  tz: string;
  company_ids: [number, string][];
  is_employee: boolean;
  parent_id: number;
}

export interface ISession {
  uid: number;
  db: string;
  user_context: {
    lang: string;
    tz: string;
    uid: number;
  };
  name: string;
  username: string;
  company_id: number;
  partner_id: number;
  "web.base.url": string;
  allowed_company_ids: number[];
  is_system: boolean;
  is_admin: boolean;
  server_version: string;
  server_version_info: [number, number, number, string, number, string];
  partner_display_name: string;
  user_companies: {
    current_company: [number, string];
    allowed_companies: [number, string, string | false][];
  };
  currencies: {
    [currencyId: string]: {
      symbol: string;
      position: "before" | "after";
      digits: [number, number];
    };
  };
  show_effect: string;
  display_switch_company_menu: boolean;
  cache_hashes: {
    load_menus: string;
    qweb: string;
    translations: string;
  };
  max_time_between_keys_in_ms: number;
  web_tours: string[];
  ks_toggle_color: boolean;
  ks_header_color: boolean;
  ks_header_text_color: string;
  ks_serial_number: boolean;
  out_of_office_message: boolean | string;
  odoobot_initialized: boolean;
  timesheet_uom: {
    id: number;
    name: string;
    rounding: number;
    timesheet_widget: string;
  };
  timesheet_uom_factor: number;
  pdf_preview_on_tab: boolean;
  j_sid: string;
  j_session_token: string;
  modules: string[];
  apm_threshold_time_in_minute: number;
  id: number;
  cookie: string;
}

export interface ICustomConfig {
  [key: string]: any;
}

export interface ICustomTheme {
  [key: string]: any;
}

export interface IOdooSession {
  config: ICustomConfig;
  session: ISession;
  theme: ICustomTheme;
  user: IUser;
}

export interface IRoute {
  path: string;
  index?: boolean;
  ignoreLayout?: boolean;
  showInMenu?: boolean;
  icon?: ReactElement;
  label?: string;
  asChild?: boolean;
  asParent?: boolean;
  component: ReactElement;
}

/** Machine error codes returned by auth_graphql; mapped to locale keys client-side. */
export enum AUTH_ERROR_CODE {
  INVALID_TOKEN = "INVALID_TOKEN",
  WEAK_PASSWORD = "WEAK_PASSWORD",
  MAIL_NOT_CONFIGURED = "MAIL_NOT_CONFIGURED",
  RESET_FAILED = "RESET_FAILED",
}

export interface IForgotPasswordRequest {
  username: string;
  db?: string;
  lang?: string;
}

export interface IForgotPasswordResponse {
  message: string;
  /** Local development only — the API never returns this in a deployment. */
  resetUrl?: string;
}

export interface IResetPasswordRequest {
  token: string;
  password: string;
}

export interface IResetPasswordResponse {
  message: string;
}
